<template>
    <div class="Background">
        <div style="display: flex; justify-content: space-between;">
            <h2 class="Title">
            라이브 관리
            </h2>

            <div class="link_location">
                라이브 <v-icon small class="mdi mdi-chevron-right" />
                <a href="/admin/Encoding-Server">라이브 관리</a>
            </div>
        </div>

            <WowzaLivestreamCreateForm />
    </div>
    
</template>
    
<script>
import WowzaLivestreamCreateForm from '@/components/livestream/WowzaLivestreamCreateForm.vue';

export default {
    components: {
        WowzaLivestreamCreateForm,
    },
}
</script>

<style lang="scss" scoped></style>